<template>
    <div>
        <ValidationObserver ref="observer">
            <b-row class="align-items-start align-items-md-center">
                <b-col cols="12" md="4" lg="5" class="mb-3 mb-md-0">
                    <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Role Name"
                        :key="resetKey"
                    >
                        <b-input placeholder="Role Name*" v-model="name" />
                        <span class="validate-error validate-error-red">
                            {{ errors[0] }}
                        </span>
                    </ValidationProvider>
                </b-col>

                <b-col cols="12" md="5" lg="5" class="mb-3 mb-md-0">
                    <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Description"
                        :key="resetKey"
                    >
                        <b-input
                            placeholder="Description*"
                            v-model="description"
                        />
                        <span class="validate-error validate-error-red">
                            {{ errors[0] }}
                        </span>
                    </ValidationProvider>
                </b-col>

                <b-col
                    cols="12"
                    md="3"
                    lg="2"
                    class="d-flex justify-content-start justify-content-md-end mt-2 mt-md-0"
                >
                    <eb-button
                        class="btn"
                        classic="btn-primary"
                        text="Create Role"
                        icon="fa fa-plus-circle mr-1"
                        iconSide="left"
                        @click="createNewRole"
                    />
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ebButton from "@/components/FormElements/Button.vue";

export default {
    name: "CreateRole",
    components: {
        ebButton,
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            name: "",
            description: "",
            resetKey: 0,
        };
    },
    methods: {
        async createNewRole() {
            const observer = this.$refs.observer;
            if (!observer) return;
            const isValid = await observer.validate();
            if (!isValid) return;

            this.$emit("newRole", {
                name: this.name,
                description: this.description,
            });

            this.name = "";
            this.description = "";
            this.resetKey++;
        },
    },
};
</script>

<style scoped>
.btn {
    height: 37px;
}

.validate-error-red {
    color: red;
}

@media (max-width: 767.98px) {
    .btn {
        width: 100%;
        margin-top: 0.5rem;
    }
}
</style>
